import(/* webpackMode: "eager" */ "/ml-microservice/app/global-error.tsx")